








import {Component, Vue} from 'vue-property-decorator';
import PageNotFound from '@v/PageNotFoundView.vue';

@Component({
  components: {
    PageNotFound,
  },
})
export default class PageNotFoundLayout extends Vue {}
